export default __webpack_public_path__ + "static/media/icon_survey_satisfied.83c1453d.svg";